import { createAsyncThunk } from '@reduxjs/toolkit';
import { getConnectwiseAgreements } from 'services/connectwise';

interface IProps {
  psaId: number;
  companyId: number;
}

export const ThunkGetConnectwiseAgreements = createAsyncThunk(
  'connectwise/getConnectwiseAgreements',
  ({ psaId, companyId }: IProps) =>
    getConnectwiseAgreements(psaId, companyId).then(res => res.data),
);
